module.exports = __webpack_public_path__ + "img/doctors_calendar.e07e162e.svg";